export const formatDocument = (doc?: string | null): string => {
	if (!doc) return "";
	const cleaned = String(doc).replace(/\D/g, "");

	if (cleaned.length === 11) {
		return cleaned.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, "$1.$2.$3-$4");
	}

	if (cleaned.length === 14) {
		return cleaned.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, "$1.$2.$3/$4-$5");
	}

	return doc;
};
